"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("@kiltprotocol/utils");
function errorCheck(delegationRootNodeInput) {
    const { cTypeHash } = delegationRootNodeInput;
    if (!cTypeHash) {
        throw utils_1.SDKErrors.ERROR_CTYPE_HASH_NOT_PROVIDED();
    }
    else
        utils_1.DataUtils.validateHash(cTypeHash, 'delegation root node ctype');
}
exports.default = errorCheck;
